/* unplugin-vue-components disabled */import script from "./GiftDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftDetails.vue?vue&type=script&setup=true&lang=js"

import "./GiftDetails.vue?vue&type=style&index=0&id=62d0ff79&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d0ff79"]])

export default __exports__